/*global google*/
import React from "react";
import axios from "axios";
import _ from "lodash";
import {
  withGoogleMap,
  GoogleMap,
  Marker,
  DirectionsRenderer
} from "react-google-maps";
import logo from "../shared/logo.svg";

const BranchesMap = withGoogleMap(props => (
  <GoogleMap
    ref={props.onMapLoad}
    defaultZoom={8}
    defaultCenter={{ lat: 51.509865, lng: -0.118092 }}
    onClick={props.onMapClick}
    onMarkerClick={props.onMarkerClick.bind(this)}
  >
    {props.markers.map((marker, index) => (
      <Marker
        {...marker}
        key={index}
        onClick={marker => {
          props.onMarkerClick(props.markers[index]);
        }}
      />
    ))}
    {props.directions && (
      <DirectionsRenderer directions={props.directions} {...props.directions} />
    )}
  </GoogleMap>
));

class Locator extends React.Component {
  constructor(props) {
    super(props);
    this.search = this.search.bind(this);
    this.getLocation = this.getLocation.bind(this);
    this.getAllBranches = this.getAllBranches.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.setMapMarkers = this.setMapMarkers.bind(this);
    this.centerMap = this.centerMap.bind(this);
    this.getCurrentDirections = this.getCurrentDirections.bind(this);
    this.state = {
      search_term: "",
      loading: true,
      loading_message: "Retrieving all Branches...",
      lat: "",
      long: "",
      branches: [],
      markers: [],
      show_find_location: false,
      marker_Branch: "",
      directions: {}
    };
  }

  componentDidMount() {
    if ("geolocation" in navigator) {
      this.setState({ show_find_location: true });
      this.getLocation();
    } else {
      this.getAllBranches();
    }
  }

  handleOnChange(e) {
    this.setState({ search_term: e.target.value });
  }

  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.search();
    }
  }

  getAllBranches() {
    axios
      .get("/branches/all", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      })
      .then(response => {
        this.setState({
          loading: false,
          branches: response.data.branches,
          marker_Branch: ""
        });
        this.setMapMarkers();
      })
      .catch(response => console.log(response));
  }

  setMapMarkers() {
    let newMarkers = [];
    _.each(this.state.branches, branch => {
      newMarkers.push({
        position: {
          lat: branch.latitude,
          lng: branch.longitude
        },
        id: branch.id,
        // TODO: Fix get asset pipeline url
        icon:
          "/assets/global/map-marker-29db1f85746855be95233c122ee242f78dcb91fd394463ae31a2bb79834ffb67.png"
      });
    });
    this.setState({
      markers: newMarkers
    });
    this.centerMap();
  }

  centerMap() {
    const branchBounds = [];

    _.each(this.state.branches, branch => {
      branchBounds.push(
        new google.maps.LatLng(branch.latitude, branch.longitude)
      );
    });

    const bounds = new google.maps.LatLngBounds();
    branchBounds.forEach(bound => bounds.extend(bound));

    if (bounds.getCenter()) {
      return bounds;
    }
  }

  getLocation() {
    if ("geolocation" in navigator) {
      this.setState({
        loading: true,
        loading_message: "Searching Branches near you..."
      });

      navigator.geolocation.getCurrentPosition(
        position => {
          this.setState({
            lat: position.coords.latitude,
            long: position.coords.longitude
          });

          axios
            .get(
              `/branches/search_by_coordinates?lat=${this.state.lat}&long=${
                this.state.long
              }`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json"
                }
              }
            )
            .then(response => {
              this.setState({
                loading: false,
                branches: response.data.branches,
                marker_Branch: ""
              });
              this.setMapMarkers();
            })
            .catch(response => console.log(response));
        },
        () => {
          this.setState({
            loading: false,
            error_message:
              "Unable to get your location right now, showing all branches. Try entering a search term."
          });
          this.search();
        }
      );
    } else {
      document.querySelector(".branches-search__find-your-location-btn").style.display = "none";
    }
  }

  search() {
    this.setState({
      loading: true,
      loading_message: "Searching branches...",
      error_message: ""
    });
    axios
      .get(`/branches/search?q=${this.state.search_term}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      })
      .then(response => {
        if (response.data.branches.length === 0) {
          this.getAllBranches();
        } else {
          this.setState({
            loading: false,
            branches: response.data.branches,
            marker_Branch: ""
          });
          this.setMapMarkers();
        }
      })
      .catch(response => console.log(response));
  }

  handleMarkerClick(marker) {
    this.setState({
      marker_Branch: marker.id
    });
    if (window.innerWidth < 768) {
      const branchesContainer = document.querySelector(".branches");
      branchesContainer.scrollIntoView();
    }
  }

  getCurrentDirections(branch) {
    const DirectionsService = new google.maps.DirectionsService();
    DirectionsService.route(
      {
        origin: new google.maps.LatLng(this.state.lat, this.state.long),
        destination: new google.maps.LatLng(branch.latitude, branch.longitude),
        travelMode: google.maps.TravelMode.DRIVING
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          this.setState({
            directions: result
          });
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );
  }

  render() {
    let find_your_location =
      this.state.show_find_location === true ? (
        <button
          className="branches-search__find-your-location-btn"
          onClick={this.getLocation}
        >
          <i className="material-icons">&#xE55C;</i>
          <span>Find Your Location</span>
        </button>
      ) : (
        ""
      );
    let error = this.state.error_message ? (
      <div className="error_message">
        <i className="material-icons">warning</i> {this.state.error_message}
      </div>
    ) : (
      ""
    );
    let summary =
      this.state.branches.length > 1 ? (
        <div className="branches-search__summary">
          <span>{this.state.branches.length}</span> branches
        </div>
      ) : (
        <div className="branches-search__summary">
          <span>{this.state.branches.length}</span> branch
        </div>
      );
    // TODO: Get logo asset from asset pipeline
    let loading =
      this.state.loading === true ? (
        <div className="loading--branches">
          <div className="message">
            <div className="sk-folding-cube">
              <div className="sk-cube1 sk-cube" />
              <div className="sk-cube2 sk-cube" />
              <div className="sk-cube4 sk-cube" />
              <div className="sk-cube3 sk-cube" />
            </div>
            <img src={logo} className="img-fluid" />
            {this.state.loading_message}
          </div>
        </div>
      ) : (
        ""
      );
    let filteredBranches = this.state.branches.filter(branch => {
      return this.state.marker_Branch != ""
        ? branch.id === this.state.marker_Branch
        : branch;
    });
    return (
      <div
        className={
          this.state.loading === true
            ? "branches-wrapper branches-wrapper--loading"
            : "branches-wrapper"
        }
      >
        {loading}
        <div className="branches">
          <div className="branches-search">
            <div className="branch-search__input-wrapper">
              <input
                type="text"
                placeholder="Search Town or Postcode..."
                className="branches-search__input"
                defaultValue={this.state.searchTerm}
                onChange={this.handleOnChange}
                onKeyPress={this.handleKeyPress}
              />
              <button className="branches-search__btn" onClick={this.search}>
                <i className="material-icons">&#xE8B6;</i>
              </button>
            </div>
            {find_your_location}
            {error}
            {summary}
          </div>
          <ul className="branches-list">
            {filteredBranches.map((branch, index) => {
              let branch_address = [];
              _.each(branch.address, line => {
                if (line) {
                  branch_address.push(line);
                }
              });
              let todays_opening_hours;
              let weekdays = [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
              ];
              let today = new Date().getDay();
              todays_opening_hours = weekdays[today];
              const directions =
                this.state.lat != "" ? (
                  <button
                    className="branch-directions"
                    onClick={() => {
                      this.getCurrentDirections(branch);
                      if (window.innerWidth < 768) {
                        const mapContainer = document.querySelector(
                          ".branches-map"
                        );
                        mapContainer.scrollIntoView();
                      }
                    }}
                  >
                    <span>Directions</span>
                    <i className="material-icons">&#xE5CC;</i>
                  </button>
                ) : (
                  ""
                );
              return (
                <li className="branch" key={index}>
                  <h4 className="branch-title">{branch.name}</h4>
                  <div className="branch-address">
                    {branch_address.map((l, i) => {
                      if (l === branch.name) return;
                      return (
                        <div key={i} className="address--line">
                          {l}
                        </div>
                      );
                    })}
                  </div>
                  <div className="branch-telephone">
                    <strong>T:</strong>
                    {branch.telephone}
                  </div>
                  <div className="branch-opening">
                    <strong>Open Today:</strong>
                    {branch.opening_hours[todays_opening_hours].open}am -
                    {branch.opening_hours[todays_opening_hours].close}pm
                  </div>
                  {directions}
                </li>
              );
            })}
          </ul>
        </div>
        <div className="branches-map">
          <BranchesMap
            containerElement={
              <div
                style={{ height: `100%`, width: `100%`, display: `block` }}
              />
            }
            mapElement={
              <div
                style={{ height: `100%`, width: `100%`, display: `block` }}
              />
            }
            onMapLoad={map => {
              if (map) {
                map.fitBounds(this.centerMap());
              }
            }}
            onMapClick={_.noop}
            markers={this.state.markers}
            onMarkerRightClick={_.noop}
            onMarkerClick={this.handleMarkerClick.bind(this)}
            directions={this.state.directions}
          />
        </div>
      </div>
    );
  }
}

export { Locator as default };
